<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-20 11:10:01
-->
<template>
	<div class="daRenCell">
		<div class="left">
			<yx-avatar :src="row.avatar_url"></yx-avatar>
		</div>
		<div class="right ml-10">
			<p class="yx-color-text-primary fz-14">{{ row.partner_name }}</p>
			<p class="yx-color-text-regular fz-12"
				><span>ID</span><span class="ml-10">{{ row.user_id }}</span></p
			>
		</div>
	</div>
</template>
<script>
import mixin from './mixin';
export default {
	mixins: [mixin],
	components: {
		
	},
};
</script>
<style lang="less" scoped>
.daRenCell {
	display: flex;
	align-items: center;
}
.name {
	color: #333333;
}
</style>